export default {
  CRM_CONVERSATIONS_TRIGGER_LINKS_MODAL: {
    path: 'conversationsUtilitiesApp/LinkModal',
    vue3: 'conversationsUtilitiesApp/vue3',
  },
  CRM_CONVERSATIONS_SNIPPETS_TEXT_SNIPPET_MODAL: {
    path: 'conversationsUtilitiesApp/TextSnippetModal',
    vue3: 'conversationsUtilitiesApp/vue3',
  },
  CRM_CONVERSATIONS_SNIPPETS_EMAIL_SNIPPET_MODAL: {
    path: 'conversationsUtilitiesApp/EmailSnippetModal',
    vue3: 'conversationsUtilitiesApp/vue3',
  },
  CRM_CONVERSATIONS_MANUAL_ACTIONS_DELETE_MODAL: {
    path: 'conversationsUtilitiesApp/DeleteManualActionsApp',
    vue3: 'conversationsUtilitiesApp/vue3',
  },
  CRM_MANAGE_TAGS_MODAL: {
    path: 'crmObjectsSettingsApp/TagModal',
    vue3: 'crmObjectsSettingsApp/vue3',
  },
  CRM_CUSTOM_VALUES_MODAL: {
    path: 'crmObjectsSettingsApp/CustomValuesModal',
    vue3: 'crmObjectsSettingsApp/vue3',
  },
  CRM_BULK_ACTION_STATISTICS_MODAL: {
    path: 'crmObjectsSettingsApp/BulkActionStatisticsModal',
    vue3: 'crmObjectsSettingsApp/vue3',
  },
}
